"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var Icon = function Icon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#2E2E2E",
    d: "M10.064 12.001 7.768 8.024l1.31-2.271.986 1.697.897-1.562a.469.469 0 0 1 .813 0l.627 1.099a.937.937 0 0 1 .002.926l-1.053 1.86-1.286 2.228z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#5C5C5C",
    d: "m12.645 16.471 1.286-2.227.83 1.439a.187.187 0 0 0 .325 0l2.567-4.467a.375.375 0 0 0 .006-.364L16.17 8.077l1.346-2.355 2.666 4.667a.937.937 0 0 1 0 .93L15.75 19.07a.937.937 0 0 1-1.629-.002l-1.476-2.598z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#939393",
    d: "m6.217 10.991 2.535 4.392c.145.25.506.25.65 0L15.825 4.2a.469.469 0 0 1 .812 0l.88 1.522L9.882 19.08a.938.938 0 0 1-1.628 0l-4.436-7.762a.937.937 0 0 1 0-.93l3.545-6.187a.469.469 0 0 1 .812-.003l.903 1.554-2.861 4.957a.281.281 0 0 0 0 .281z"
  }));
};
Icon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
var config = {
  angConfiguration: {
    typeURL: 'http://anypoint.com/vocabs/digital-repository#DataWeaveLibraryAsset',
    assetType: 'DataWeaveLibrary'
  },
  owner: {
    gusTeam: 'MS DataWeave',
    gusTeamLink: 'https://gus.lightning.force.com/lightning/r/ADM_Scrum_Team__c/a00AH000000in0qYAA/view'
  },
  name: 'DataWeave Library',
  pluralName: 'DataWeave Libraries',
  featureFlag: 'dw-libraries-enabled',
  publication: {
    inferredBy: [{
      classifiers: ['dw-library']
    }],
    files: [{
      id: 'dw-library',
      classifier: 'dw-library',
      packaging: 'jar'
    }],
    minimumInputSets: [{
      files: ['dw-library']
    }]
  },
  portal: {
    icon: Icon,
    color: '#46A1D8',
    // futureGreen3
    files: [{
      fileId: 'dw-library',
      label: 'DataWeave Library'
    }]
  },
  keywords: ['transformation', 'weave', 'dw', 'dataweave']
};
var _default = exports.default = config;
//# sourceMappingURL=config.js.map